import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

class Bar extends AbstractChart {
    protected allChartOptions(): Options {
        const yAxisLabels = $(this.target).data('options')['y-axis-labels'] ?? {};
        const options: Options = {
            chart: {
                type: 'bar',
                marginRight: 50,
                marginLeft: 190, // match with x-axis-label-text:width + 10px
                spacingBottom: 10,
                spacingTop: 10,
                width: 660,
                height: 580
            },
            xAxis: {
                labels: {
                    // xAxis is labelled separately outside the chart
                    enabled: false,
                    style: {
                        width: 190 // match with options.chart.marginLeft
                    }
                }
            },
            yAxis: {
                labels: {
                    formatter: function () {
                        return yAxisLabels[this.value] ?? this.value.toString();
                    },
                    enabled: true,
                    useHTML: true,
                    style: {
                        whiteSpace: 'wrap',
                        color: 'black'
                    },
                },
                min: 0,
                max: 100,
                tickInterval: 10,
                startOnTick: true, // Ensure bars start at the 0 tick
                endOnTick: true, // Ensure bars end at the max tick
                title: {
                    text: null
                }
            },
            plotOptions: {
                bar: {
                    borderWidth: 0,
                    pointWidth: 12 // Bar height
                }
            },
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

// noinspection JSUnusedGlobalSymbols
export default function () {
    registerPlugin(Bar)
}
